import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import { Box, RootRef } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUploadOutlined';
import { Flex } from './Flex';

const LineText = styled(({ className, text }) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    py={3}
    className={className}
  >
    <hr />
    <Box px={2}>{text}</Box>
    <hr />
  </Flex>
))`
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights[5]};
  max-width: 100%;

  hr {
    height: 2px;
    width: 100px;
    border-color: ${({ theme }) => theme.colors.blacks[0]};
    line-height: normal;
  }

  span {
    color: ${({ theme }) => theme.colors.blacks[3]};
  }
`;

const Uploader = ({
  className,
  onDrop,
  accept,
  dropZoneIcon,
  bottomComponent,
  maxSize,
  minSize,
  selectedFile,
  inactiveText,
}) => {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    accept,
    maxSize,
    minSize,
  });
  const { ref, ...rootProps } = getRootProps();

  const Icon = isDragActive ? CloudUploadIcon : dropZoneIcon;
  const text = isDragActive
    ? 'Drop files here'
    : inactiveText || 'Drag & Drop to Upload';

  return (
    <RootRef rootRef={ref}>
      <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        p={3}
        className={`${className} ${isDragActive ? 'dragging' : ''}`}
        {...rootProps}
      >
        <input {...getInputProps()} data-testid="file-upload" />
        {selectedFile ? (
          <>
            <Icon className="icon" />
            <Box className="selected-file" data-testid="selected-file" pt={3}>
              {selectedFile.name}
            </Box>
          </>
        ) : (
          <>
            <Flex flexDirection="column" alignItems="center">
              <Icon className="icon" />
              <Box>{text}</Box>
            </Flex>

            {!isDragActive && (
              <>
                <LineText text="or" />
                {bottomComponent({ open })}
              </>
            )}
          </>
        )}
      </Flex>
    </RootRef>
  );
};

const StyledUploader = styled(Uploader)`
  && {
    font-size: ${({ theme }) => theme.fontSizes[1]};
    font-weight: ${({ theme }) => theme.fontWeights[6]};
    text-align: center;
    border: 4px dashed ${({ theme }) => theme.colors.neutrals[3]};
    border-radius: 4px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.blacks[4]};
    min-width: 240px;

    .selected-file {
      width: 100%;
      overflow: hidden;
    }

    &.dragging {
      background-color: ${({ theme }) => theme.colors.blacks[0]};
    }

    .icon {
      font-size: 80px;
    }
  }
`;

export default StyledUploader;
